import React, { FunctionComponent } from 'react'
import { ProductInfo, ProductInfoData } from '../components/product-info'
import { ProductPageOuter } from '../components/product-page-components'
import { ProductStepSection, ProductStepSectionData } from '../sections/product-step-section'
import { VerticalSpacer } from '../components/spacer'
import { ProductVariationSection, ProductVariationSectionData } from '../sections/product-variation-section'
import { ProductDetailSection, ProductDetailSectionData } from '../sections/product-detail-section'
import { SetProductsSectionHydroLight25 } from '../sections/set-products-section'
import { UseSection } from './use-section'
import { HowToSection } from '../sections/how-to-section'
import { ProductBannerHydroLightSection } from '../sections/product-banner-section'
import { CycleSection2 } from '../sections/cycle-section'
import { SubscriptionBannerSection } from '../sections/subscription-banner-section'
import { LineUpSection } from '../sections/line-up-section'
import SvgProductStepGraph05 from '../generated/svg/product-step-graph-05'
import { productSku } from '../product-sku'
import { skuToUrl } from '../utils/sku-to-url'
import { CautionSecton } from '../sections/caution-secton'

const productInfoData: ProductInfoData = {
  images: [
    'p3-1.png'
  ],
  brandName: 'SKN REMED',
  name: <>
    HydroLight™ 2.5
  </>,
  nameJa: 'ハイドロライトクリーム2.5',
  info: [
    {
      label: '内容量',
      value: '15g'
    }
  ],
  variations: [
    {
      label: '2.5',
      color: '#C6B7D8',
      link: skuToUrl(productSku.hydroLight25.single),
      active: true
    },
    {
      label: '4.0',
      color: '#A98EBB',
      link: skuToUrl(productSku.hydroLight40.single),
    }
  ],
  checkoutNote: <>
    <ul>
      <li>初めて使用の方は、必ず使用前にパッチテストをおこなってください。</li>
      <li>美白剤や毛染め、内容成分でアレルギーを起こしたことがある方はご使用をお控えください。</li>
      <li>妊娠中、授乳中は肌が敏感になりやすいためご使用をお控えいただくことをおすすめしています。</li>
      <li>商品の配送は通常の運送便にて常温で配送されますが、到着後は冷蔵庫での保管をお願いいたします。</li>
      <li>HydroLight™️の美容クリームのケアは、お肌への効果と安全性を考え、4ヵ月の継続使用後、4ヵ月のお休み期間が必要となります。</li>
    </ul>
  </>,
  singleSku: productSku.hydroLight25.single,
  subscriptionSku: productSku.hydroLight25.subscription,
  agreement: <>
    <ul>
      <li>初めて使用の方は、必ず使用前にパッチテストをおこなってください。</li>
      <li>美白剤や毛染め、内容成分でアレルギーを起こしたことがある方はご使用をお控えください。</li>
      <li>妊娠中、授乳中の方は、肌が敏感になりやすいためご使用を控えていただくことをお勧めいたします。</li>
      <li>肌が敏感な状態の時、美容施術の前後（前後1週間） 、皮膚科で治療を受けている期間、長時間紫外線を浴びる予定がある時の使用は控えてください。</li>
      <li>使用中は、紫外線ダメージを受けやすいため、日中は日焼け止め等で紫外線対策をおこなってください。</li>
      <li>他のレチノール・ハイドロキノン製品とは併用しないでください。</li>
      <li>使用の際、まれに赤み等の異常が出ることがあります。軽い刺激ですぐにおさまるものであれば、ご使用いただけます。ピリピリ感が治らない場合、赤み・刺激感・かゆみなどのアレルギーのような反応、強い刺激や他の症状がある場合には一旦使用を中止し、様子を見てください。使用を中止しても治まらない場合は、皮膚科専門医にご相談ください。</li>
      <li>商品の配送は通常の運送便にて常温で配送されますが、到着後は冷蔵庫での保管をお願いいたします。</li>
      <li>ハイドロライトの美容クリームのケアは、お肌への効果と安全性を考え、4ヵ月の継続使用後、4ヵ月のお休み期間が必要となります。</li>
    </ul>
  </>
}
export const productStepSectionData: ProductStepSectionData = {
  backgroundImg: 'p3-10.png',
  graph: <SvgProductStepGraph05 />,
  step: 2,
  stepColor: '#C6B7D8',
  text1: <>
    HydroLight™ Cream
  </>,
  text2: <>
    高濃度の集中ケア
  </>,
  text3: <>
    ハイドロライトクリームは、ハイドロキノン※配合の美容クリームです。
    スキンサイクルメソッドではDAY.2に使用を推奨。キメを整え、
    輝きを放つ美しい肌へ導きます。
    （レチノダーマクリームとの併用はできません）
  </>,
  note: <>
    ※整肌成分
  </>
}

export const productVariationSectionData: ProductVariationSectionData = {
  items: [
    {
      img: 'p3-3.png',
      name: <>
        HydroLight™ 2.5
      </>,
      text: <>
        ハイドロキノン<sup>※1</sup>を初めて使う人向けの、全顔のくすみ<sup>※2</sup>ケアに。成分の強さと肌への負担を意識した配合バランスです。
      </>,
      list: [
        {
          label: '使用方法(目安)',
          items: [
            '目立たない部分に小豆1粒～ ',
            '反応がなかったらパール1粒へ'
          ]
        },
        {
          label: '使用回数(目安)',
          items: [
            '1～3日に1回'
          ]
        },
        {
          label: '購入条件',
          items: [
            '初めての方でもご購入可能。',
            'ハイドロキノンはまれにアレルギーの方がいらっしゃるため、ご使用前にパッチテストしていただくようお願いいたします。'
          ]
        }
      ],
      night: true,
      color: '#C6B7D8'
    },
    {
      img: 'p3-4.png',
      name: <>
        HydroLight™ 4.0
      </>,
      text: <>
        ハイドロキノン<sup>※1</sup>に慣れた上級者の方や、スポットケアに役立つアイテム。深刻な肌悩みに攻めのケアを。
      </>,
      list: [
        {
          label: '使用方法(目安)',
          items: [
            '目立たない部分に小豆1粒～',
            '反応がなかったらパール1粒へ'
          ]
        },
        {
          label: '使用回数(目安)',
          items: [
            '1～3日に1回（濃い悩みなど部分的に使用推奨）'
          ]
        },
        {
          label: '購入条件',
          items: [
            'グレード2.5にて反応が出なかった方で、希望があれば注意事項に同意のうえグレードアップの検討も可能です。',
          ]
        }
      ],
      night: true,
      color: '#A98EBB'
    },
  ],
  text1: <>
    選べる2段階のハイドロキノン<sup>※1</sup>グレード
  </>,
  text2: <>
    ハイドロキノン<sup>※1</sup>を配合しながら全顔のくすみ<sup>※2</sup>ケア・濃いスポットケアなど、
    それぞれ使い分けれるように2段階の処方濃度でラインアップしています。
  </>,
  text3: <>
  </>,
  caution: <>
    ※ 【HydroLight™】Hクリームを2個(約4ヶ月分)ご購入後、お休み期間(約4ヶ月)はご購入できません。<br />
    お休み期間中は【RetinoDerm™】または【NiacinaGlow™】でケアをお勧めしています。
  </>,
  note: <>
    ※1 ハイドロキノン（整肌成分） ※2 乾燥してキメが乱れた肌印象のこと<br />
    ※3ハイドロキノンにて以前アレルギーのある方は不可
  </>
}

export const productDetailSectionData: ProductDetailSectionData = {
  img1: 'p3-6.png',
  img2: 'p3-7.png',
  img3: 'p3-8.png',
  img4: 'p3-9.png',
  text1: <>
    4種のバリアケアブレンド<sup>※1</sup>
  </>,
  text2: <>
    ハイドロキノン<sup>※2</sup>の肌への負担をやわらげるため、
    肌の潤いバリアケアを重視して選ばれた厳選成分を4種<sup>※1</sup>配合。
    乾燥から肌を守り、健やかな肌へ導きます。
  </>,
  text3: <>
    攻めながらもしっかりと保水し<br />
    健やかな肌へ
  </>,
  text4: <>
    集中ケアの時にかかる肌への負担を考えて、保水成分をたっぷりと配合。
    潤いバリアをサポートする【5種のセラミド配合カプセル<sup>※3</sup>】を配合し、
    乾燥から肌を守ります。
  </>,
  note1: <>
    ※1 アラントイン、ツボクサエキス、マデカッソシド、グリチルリチン酸２Ｋ（すべて整肌成分）<br />
    ※2 ハイドロキノン（整肌成分）<br />
    ※3 セラミドＮＧ、セラミドＡＰ、セラミドＡＧ、セラミドＮＰ、セラミドＥＯＰ（すべて保湿成分）
  </>,
  text5: <>
    成分品質を守るエアレスチューブ
  </>,
  text6: <>
    酸素や温度に弱く安定性の悪い成分を、きちんと角質層へ届けるため
    エアレス容器を採用。
    空気に触れにくく密封性に優れ、
    最後までハイドロキノン<sup>※</sup>の成分を守ります。
    未開封、開封後ともに冷蔵庫保存がおすすめです。
  </>,
  note2: <>
  </>
}

type ProductHydroLight25PageProps = {

}
export const ProductHydroLight25Page: FunctionComponent<ProductHydroLight25PageProps> = () => {
  return <ProductPageOuter>
    <ProductInfo
      data={productInfoData}
    />
    <VerticalSpacer length='4rem' />
    <CautionSecton>
      ※ 【HydroLight™】Hクリームを2個(約4ヶ月分)ご購入後、お休み期間(約4ヶ月)はご購入できません。<br />
      お休み期間中は【RetinoDerm™】または【NiacinaGlow™】でケアをお勧めしています。
    </CautionSecton>
    <VerticalSpacer length='4rem' />
    <ProductStepSection
      data={productStepSectionData}
    />
    <VerticalSpacer length='4rem' />
    <ProductVariationSection
      data={productVariationSectionData}
    />
    {/* <VerticalSpacer length='4rem' />
    <TopCounselingSection /> */}
    <VerticalSpacer length='8rem' />
    <ProductDetailSection
      data={productDetailSectionData}
    />
    <VerticalSpacer length='8rem' />
    <SetProductsSectionHydroLight25 />
    <VerticalSpacer length='8rem' />
    <UseSection />
    <VerticalSpacer length='8rem' />
    <HowToSection use={['peelCare', 'hydroLight', 'niacinaGlow']} initial={'hydroLight'}/>
    <VerticalSpacer length='8rem' mLength='4rem' />
    <ProductBannerHydroLightSection />
    <VerticalSpacer length='8rem' mLength='4rem' />
    <CycleSection2 />
    {/* <VerticalSpacer length='8rem' mLength='4rem' />
    <UsersVoiceSection /> */}
    <VerticalSpacer length='8rem' mLength='4rem' />
    <ProductInfo
      data={productInfoData}
    />
    <VerticalSpacer length='8rem' mLength='4rem' />
    <SubscriptionBannerSection color="#E4E1E8"/>
    <VerticalSpacer length='8rem' mLength='4rem' />
    <LineUpSection />
  </ProductPageOuter>
}